<script>
export default {
  props: {
    x: {
      type: Number,
      default: 0,
    },
    y: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      left: this.x,
      top: this.y,
      show: false,
    };
  },
  computed: {
    style() {
      return {
        top: this.top + 'px',
        left: this.left + 'px',
      };
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.keepInsideViewport();
      this.$el.focus();
    });
  },
  methods: {
    // Chatsell: se abría exactamente donde se hizo clic; cerca del borde
    // inferior (mensajes de abajo del hilo) el menú quedaba cortado. Se
    // corre hacia arriba / a la izquierda lo necesario para que entre.
    keepInsideViewport() {
      const MARGIN = 8;
      const { width, height } = this.$el.getBoundingClientRect();
      const maxTop = window.innerHeight - height - MARGIN;
      const maxLeft = window.innerWidth - width - MARGIN;
      this.top = Math.max(MARGIN, Math.min(this.top, maxTop));
      this.left = Math.max(MARGIN, Math.min(this.left, maxLeft));
    },
  },
};
</script>

<template>
  <div
    class="fixed outline-none z-[9999] cursor-pointer"
    :style="style"
    tabindex="0"
    @blur="$emit('close')"
  >
    <slot />
  </div>
</template>
